<template>
  <div v-shortkey="['ctrl', '/']" class="d-flex flex-grow-1">
    <!-- Navigation -->

    <!-- Toolbar -->
    <v-app-bar app>
      <v-card
        class="flex-grow-1 d-flex"
        :class="[isToolbarDetached ? 'pa-1 mt-3 mx-1' : 'pa-0 ma-0']"
        :flat="!isToolbarDetached"
      >
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <div class="d-flex flex-grow-1 align-center">
            <v-toolbar-title>Aspire</v-toolbar-title>
            <div v-if="isArchitect()" class="ml-3">
              <v-btn text to="/" active-class="primary">Projects</v-btn>
              <v-btn text>RFQ</v-btn>
              <v-btn text>Support</v-btn>
              <v-btn text>Contact</v-btn>
            </div>

            <div v-if="isDealer()" class="ml-3">
              <v-btn text to="/dealer/rfq" active-class="primary">RFQ</v-btn>
              <v-btn text>Support</v-btn>
              <v-btn text>Contact</v-btn>
            </div>

            <div v-if="isAdmin()" class="ml-3">
              <v-btn text to="/admin-users" active-class="primary"
                >Admin Users</v-btn
              >
              <v-btn text to="/dealers" active-class="primary">Dealers</v-btn>
              <v-btn text to="/contractors" active-class="primary"
                >Contractors</v-btn
              >
              <v-btn text to="/architects" active-class="primary">Architects</v-btn>
              <!-- <v-btn text to="/" active-class="primary">Projects</v-btn> -->
              <v-btn text>Support</v-btn>
            </div>

            <div
              class="d-flex flex-grow-1 align-center "
              style="flex-direction: row-reverse;"
            >
              <toolbar-user />
              <div class="mx-2 hidden-xs-only">
                <toolbar-notifications />
              </div>
              <toolbar-apps />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="d-flex flex-grow-1 justify-space-between align-center">
            <v-toolbar-title>Aspire</v-toolbar-title>
            <v-app-bar-nav-icon
              @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
            <template>
              <v-navigation-drawer app v-model="drawer" absolute temporary>
                <v-toolbar-title class="px-2">Aspire</v-toolbar-title>
                <v-list nav dense>
                  <v-list-item-group active-class="primary--text">
                  </v-list-item-group>
                </v-list>
              </v-navigation-drawer>
            </template>
          </div>
        </template>
      </v-card>
    </v-app-bar>

    <v-main style="width:100%;padding: 56px 0px 27px;">
      <v-container
        style="width:100%"
        class="fill-height"
        :fluid="!isContentBoxed"
      >
        <v-layout>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapState } from "vuex";

// navigation menu configurations
import config from "../configs";

import ToolbarUser from "../components/toolbar/ToolbarUser";
import ToolbarApps from "../components/toolbar/ToolbarApps";
import ToolbarNotifications from "../components/toolbar/ToolbarNotifications";
export default {
  components: {
    ToolbarUser,
    ToolbarApps,
    ToolbarNotifications
  },
  data() {
    return {
      drawer: false,
      showSearch: false,

      navigation: config.navigation,
      isContentBoxed: false,
      isToolbarDetached: false
    };
  },
  computed: {
    ...mapState("app", [
      "product",
      "menuTheme",
      "toolbarTheme",
      "isToolbarDetached"
    ])
  },
  methods: {}
};
</script>
